// @flow

import {
  getActivePdbId,
  getMileages as getPdbMileages,
} from '../../../pdb/selectors';
import {
  getReducer,
} from './main';
import type { ActivesState as State } from '../types';
import type { State as ConfigState } from '../../types';
import type { State as PdbState } from '../../../pdb/types';
import type { OrderFormState } from '../../../orderForm/types';
import type { Mileage } from '../../../../types/pdb';

type GlobalState = {
  configuration: ConfigState,
  pdb: PdbState,
  orderForm: OrderFormState,
};

/**
 * We export the function to get all mileages for a car here, since we do that for
 * all actives. The reason is that some car properties depend on choices of other
 * car properties.
 */
export const getMileages = (state: GlobalState, pdbId?: ?string): Array<Mileage> => (
  getPdbMileages(state, pdbId)
);

type ActiveMileage = $PropertyType<State, 'activeMileage'>;
export const getMileageFromActives = (state: GlobalState, pdbId?: ?string) => {
  const selectedPdbId = pdbId || getActivePdbId(state);
  const reducer: ActiveMileage = getReducer(state).activeMileage;
  return reducer[selectedPdbId] || null;
};

type MileageId = $PropertyType<Mileage, 'id'>;
export const getActiveMileageId = (state: GlobalState, pdbId?: ?string): ?MileageId => {
  const value = getMileageFromActives(state, pdbId);
  return typeof value === 'number' ? value : null;
};

export const getActiveMileage = (state: GlobalState, pdbId?: ?string): ?Mileage => {
  const mileages = getMileages(state, pdbId);
  const active = getActiveMileageId(state, pdbId);
  return (mileages && active) ? mileages.find(x => x.id === active) : null;
};

type MileageValue = $PropertyType<Mileage, 'mileage'>;
export const getActiveMileageValue = (state: GlobalState, pdbId?: ?string): ?MileageValue => {
  const mileage = getActiveMileage(state, pdbId);
  return mileage ? mileage.mileage : null;
};

export default null;
